import "./App.css";
import "./element.css";
import Home from "./components/Home";
import { Route, Routes } from "react-router-dom";
import WalkInList from "./components/WalkInList";
import WalkInDescription from "./components/walkInDescription/walkInDescription";
import { path } from "./constant";
import AboutUs from "./components/AboutUs";
import PrivacyPolicy from "./components/PrivacyPolicy"
import TermsofUse from "./components/TermsofUse"
import CopyrightNotice from "./components/CopyrightNotice"
import Frame from "./components/Frame";
import ContactUsPage from './components/contactUs/ContactUsPage'
import PageNotFound from './components/pageNotFound/PageNotFound'
function App() {
  return (
  
   < Routes>
  <Route path="/" element={      <Home />} > </Route>
  <Route path={path.searchPagelink} element={<WalkInList />} ></Route>
  <Route path="/walkin" element={<WalkInDescription />} ></Route>
  <Route  element={<Frame></Frame>}>
  <Route path={path.aboutus} element={<AboutUs></AboutUs>} ></Route>
  <Route path={path.terms} element={<TermsofUse></TermsofUse>} ></Route>
  <Route path={path.copyright} element={<CopyrightNotice></CopyrightNotice>} ></Route>
  <Route path={path.privacypolicy} element={<PrivacyPolicy></PrivacyPolicy>} ></Route>
  <Route path={path.contactus} element={<ContactUsPage></ContactUsPage>} ></Route>
  <Route path={path.notfound} element={<PageNotFound></PageNotFound>} ></Route>
  </Route>
  </Routes>

  );
}

export default App;
